export var defaultProps = {
    className: '',
    size: 'normal',
    loading: true,
    tip: '',
    wrapperClassName: '',
};
